import React, { useState, useEffect, useCallback } from 'react';
import Pagination from './Pagination';
import './ServerErrors.css';

const API_BASE = '/api';

function ServerErrors() {
  const [errors, setErrors] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, limit: 50, total: 0, totalPages: 0 });
  const [loading, setLoading] = useState(true);
  const [expandedRows, setExpandedRows] = useState(new Set());

  const getDefaultDates = () => {
    const now = new Date();
    const y = now.getFullYear(), m = String(now.getMonth()+1).padStart(2,'0'), d = String(now.getDate()).padStart(2,'0');
    return { start: `${y}-${m}-01`, end: `${y}-${m}-${d}` };
  };
  const defaults = getDefaultDates();

  const [filterType, setFilterType] = useState('');
  const [filterStartDate, setFilterStartDate] = useState(defaults.start);
  const [filterEndDate, setFilterEndDate] = useState(defaults.end);
  const token = localStorage.getItem('token');

  const fetchErrors = useCallback(async (page = 1) => {
    setLoading(true);
    try {
      const params = new URLSearchParams({ page, limit: 50 });
      if (filterType) params.append('type', filterType);
      if (filterStartDate) params.append('startDate', filterStartDate);
      if (filterEndDate) params.append('endDate', filterEndDate);

      const res = await fetch(`${API_BASE}/server-errors?${params}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (data.success) {
        setErrors(data.errors);
        setPagination(data.pagination);
      }
    } catch (err) {
      console.error('Server errors fetch error:', err);
    }
    setLoading(false);
  }, [filterType, filterStartDate, filterEndDate, token]);

  useEffect(() => {
    fetchErrors();
  }, [fetchErrors]);

  const handleClearAll = async () => {
    if (!window.confirm('Tüm server hataları silinecek. Emin misiniz?')) return;
    try {
      const res = await fetch(`${API_BASE}/server-errors`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (data.success) {
        fetchErrors();
      }
    } catch (err) {
      console.error('Clear errors error:', err);
    }
  };

  const toggleRow = (id) => {
    setExpandedRows(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const fmtTime = (iso) => {
    if (!iso) return '-';
    return new Date(iso).toLocaleString('tr-TR', {
      timeZone: 'Europe/Istanbul',
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
    });
  };

  const clearFilters = () => {
    const d = getDefaultDates();
    setFilterType('');
    setFilterStartDate(d.start);
    setFilterEndDate(d.end);
  };

  return (
    <div className="server-errors">
      <div className="se-header">
        <div className="se-header-left">
          <h2>⚠️ Server Hataları</h2>
          <span className="se-stat">{pagination.total} hata</span>
        </div>
        <div className="se-header-right">
          <button className="se-btn se-btn-danger" onClick={handleClearAll}>🗑️ Tümünü Sil</button>
        </div>
      </div>

      <div className="se-filters">
        <select value={filterType} onChange={e => setFilterType(e.target.value)}>
          <option value="">Tüm Tipler</option>
          <option value="unhandledRejection">Unhandled Rejection</option>
          <option value="uncaughtException">Uncaught Exception</option>
        </select>
        <input type="date" value={filterStartDate} onChange={e => setFilterStartDate(e.target.value)} />
        <input type="date" value={filterEndDate} onChange={e => setFilterEndDate(e.target.value)} />
        <button className="se-btn" onClick={clearFilters}>Temizle</button>
      </div>

      {loading ? (
        <div className="se-loading">Yükleniyor...</div>
      ) : errors.length === 0 ? (
        <div className="se-empty">✅ Hiç server hatası yok</div>
      ) : (
        <>
          <div className="se-table-wrap">
            <table className="se-table">
              <thead>
                <tr>
                  <th>Tarih</th>
                  <th>Tip</th>
                  <th>Mesaj</th>
                </tr>
              </thead>
              <tbody>
                {errors.map(err => (
                  <React.Fragment key={err._id}>
                    <tr className="se-row" onClick={() => toggleRow(err._id)}>
                      <td className="se-col-date">{fmtTime(err.createdAt)}</td>
                      <td>
                        <span className={`se-type ${err.type === 'uncaughtException' ? 'se-type-exc' : 'se-type-rej'}`}>
                          {err.type === 'uncaughtException' ? '💥 Exception' : '⚡ Rejection'}
                        </span>
                      </td>
                      <td className="se-col-msg">{err.message || '-'}</td>
                    </tr>
                    {expandedRows.has(err._id) && (
                      <tr className="se-expanded">
                        <td colSpan={3}>
                          <pre className="se-stack">{err.stack || 'Stack trace yok'}</pre>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
          <Pagination
            page={pagination.page}
            totalPages={pagination.totalPages}
            total={pagination.total}
            onPageChange={(p) => fetchErrors(p)}
          />
        </>
      )}
    </div>
  );
}

export default ServerErrors;
